import React, { useState } from 'react';
import { useFormik } from 'formik';
import { TextField, Button, Container, Box, Typography } from '@mui/material';
import { sendPasswordResetEmail } from '../../Api/AuthApi';
import { useTranslation } from 'react-i18next';
import { AlertBar } from '../Utils/Utils';

export default function ForgotPasswordForm() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ severity: 'info', message: '' });

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                await sendPasswordResetEmail(values.email);
                setAlertInfo({ severity: 'success', message: t('resetEmailSent') });
            } catch (err) {
                setAlertInfo({ severity: 'error', message: err.message || t('resetEmailError') });
            }
            setOpen(true);
            setSubmitting(false);
        },
    });

    const handleClose = () => setOpen(false);

    return (
        <Container maxWidth="sm">
            <Box sx={{ marginTop: 12, textAlign: 'center' }}>
                <Typography variant="h5">{t('forgotpass')}</Typography>
            </Box>
            <Box sx={{ mt: 3 }}>
                <form onSubmit={formik.handleSubmit}>
                    <TextField
                        fullWidth
                        margin="normal"
                        id="email"
                        name="email"
                        label={t('email')}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                    />
                    <Button
                        color="primary"
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 2 }}>
                        {t('sendResetLink')}
                    </Button>
                </form>
            </Box>
            <AlertBar open={open} handleClose={handleClose} message={alertInfo.message} severity={alertInfo.severity} />
        </Container>
    );
}
